// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"h9-z"};